import apiAction from 'common/redux/actions/apiAction';
import { GET_UPG_MY_PROFILE_JOB_ROLE_DETAILS} from  '../apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getMyProfileJobRoleDetails = (data) => {
    return {
      type: 'GET_UPG_MY_PROFILE_JOB_ROLE_DETAILS',
      payload: data,
    };
  };
export const MyProfileJobRoleDetailsAction= (params) => {
    return apiAction.postAPI({
        url: GET_UPG_MY_PROFILE_JOB_ROLE_DETAILS(),
        data: params,
        onSuccess: getMyProfileJobRoleDetails,
        onFailure: (err) => logError('Error fetching job role details...:', err),
        label: 'FETCH_UPG_MY_PROFILE_JOB_ROLE_DETAILS',
      }); 
}